import React, { useEffect, useState } from "react";
import resumeData from "../../../resumeData/resumeData";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { easeQuadInOut } from "d3-ease";
import "./Skills.css";
import AnimatedProgressProvider from "../../AnimatedProgressProvider";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Skills = () => {
  const resume = resumeData[0];
  const skillmessage = resume.skillmessage;

  const [scroll, setScroll] = useState(0);

  function handleScroll(event) {
    setScroll(window.scrollY - 1200);
    // console.log(window.scrollY)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000, offset: 150, });
  }, []);
  
  const [mouseEnter, setMouseEnter] = useState(false);
  const [rowSkillMouseEnter, setRowSkillMouseEnter] = useState(false);
  // console.log(mouseEnter)

  const skills = resume.skills.map((skills, index) => {
    var className = "bar-expand " + skills.name.toLowerCase();
    return (
      <li key={skills.name} data-aos="fade-up-right" data-aos-offset="0" data-aos-delay={50*index}>
        <AnimatedProgressProvider
          valueStart={0}
          valueEnd={Number(skills.level.substring(0, 2))}
          duration={1}
          delay={100*index}
          easingFunction={easeQuadInOut}
          // repeat={}
          rowSkillMouseEnter={rowSkillMouseEnter}
        >
          {value => {
            return (
              <span style={{ width: `${value}%` }} className={className}></span>
            );
          }}
        </AnimatedProgressProvider>

        <span className="skill_technology"> {skills.name} - <span style={{ color: "#00ffd5" }}>{`(${skills.level})`}</span> </span>
      </li>
    );
  });
  return (
    <div className="skill-section"
      onMouseEnter={() => setMouseEnter(true)}
      // onMouseLeave={() => setMouseEnter(false)}
    >
      <div className="container-fluid skill-container-top">
        <div className="scroll-text" >
          <p className=""
            style={{ transform: `translateX(${scroll}%)` }}
          >
            SKILLS
          </p>
        </div>
        <h2
          style={{
            color: "#00ffd5",
            textAlign: "center",
            marginTop: "-60px",
            marginBottom: "80px",
            fontSize: '36px',
            position: 'relative',
            zIndex: 2,
            fontWeight: 'bold'
          }}
        >
          MY SKILLS
          <div style={{ display: "flex", justifyContent: "center", marginTop: '16px', zIndex: 9999, }}>
            <div className="main">
              <div className="ball"></div>
            </div>
          </div>
        </h2>

        {/* <h2
        style={{
          color: "#00ffd5",
          textAlign: "center",
          marginTop: "40px",
          marginBottom: "40px",
        }}
      >
        <span> MY SKILLS</span>
      </h2> */}

        <div className="skill_card_main" onMouseEnter={() => setRowSkillMouseEnter(true)}>
          <div className="skill_card" data-aos="fade-up" data-aos-offset="0">
            <AnimatedProgressProvider
              valueStart={0}
              valueEnd={95}
              duration={1.4}
              easingFunction={easeQuadInOut}
              // repeat={mouseEnter}
              mouseEnter={mouseEnter}
            >
              {value => {
                const roundedValue = Math.round(value);
                return (
                  <div className="circular-progress-bar"> 
                    <CircularProgressbar
                      value={value}
                      text={`${roundedValue}%`}
                      /* This is important to include, because if you're fully managing the
                      animation yourself, you'll want to disable the CSS animation. */
                      styles={buildStyles({ pathTransition: "none" })}
                    />
                  </div>
                );
              }}
            </AnimatedProgressProvider>
            <p className="text-center pt-2">Front-end Development</p>
          </div>
          <div className="skill_card" data-aos="fade-up" data-aos-offset="0" data-aos-delay="300">
            {/* <CircularProgressbar value={60} text="60%" /> */}
            <AnimatedProgressProvider
              valueStart={0}
              valueEnd={70}
              duration={1.6}
              easingFunction={easeQuadInOut}
            // repeat
              mouseEnter={mouseEnter}
            >
              {value => {
                const roundedValue = Math.round(value);
                return (
                  <div className="circular-progress-bar"> 
                    <CircularProgressbar
                      value={value}
                      text={`${roundedValue}%`}
                      /* This is important to include, because if you're fully managing the
                      animation yourself, you'll want to disable the CSS animation. */
                      styles={buildStyles({ pathTransition: "none" })}
                    />
                  </div>
                );
              }}
            </AnimatedProgressProvider>
            <p className="text-center pt-2">Back-end Development</p>
          </div>
          <div className="skill_card" data-aos="fade-up" data-aos-delay="600" data-aos-offset="0">
            <AnimatedProgressProvider
              valueStart={0}
              valueEnd={75}
              duration={1.8}
              easingFunction={easeQuadInOut}
            // repeat
              mouseEnter={mouseEnter}
            >
              {value => {
                const roundedValue = Math.round(value);
                return (
                  <div className="circular-progress-bar"> 
                    <CircularProgressbar
                      value={value}
                      text={`${roundedValue}%`}
                      /* This is important to include, because if you're fully managing the
                      animation yourself, you'll want to disable the CSS animation. */
                      styles={buildStyles({ pathTransition: "none" })}
                    />
                  </div>
                );
              }}
            </AnimatedProgressProvider>
            <p className="text-center pt-2">MERN Stack Development</p>
          </div>
          <div className="skill_card" data-aos="fade-up" data-aos-delay="900" data-aos-offset="0">
            <AnimatedProgressProvider
              valueStart={0}
              valueEnd={80}
              duration={1.4}
              easingFunction={easeQuadInOut}
            // repeat
              mouseEnter={mouseEnter}
            >
              {value => {
                const roundedValue = Math.round(value);
                return (
                  <div className="circular-progress-bar"> 
                    <CircularProgressbar
                      value={value}
                      text={`${roundedValue}%`}
                      /* This is important to include, because if you're fully managing the
                      animation yourself, you'll want to disable the CSS animation. */
                      styles={buildStyles({ pathTransition: "none" })}
                    />
                  </div>
                );
              }}
            </AnimatedProgressProvider>
            <p className="text-center pt-2">SEO & Optimization</p>
          </div>
        </div>

        <div className="row skills" onMouseEnter={() => setRowSkillMouseEnter(true)}>
          <div className="col-md-6 main-col">
            <div className="bars">
              <ul className="skills" style={{ color: "#00ffd5", paddingLeft: "0px", marginLeft: "0", marginRight: "0" }}>
                {skills.slice(0, 4)}
              </ul>
            </div>
          </div>

          <div className="col-md-6 main-col">
            <div className="bars">
              <ul className="skills" style={{ color: "#00ffd5", paddingRight: "0px", marginRight: "0", }}>
                {skills.slice(4)}
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Skills;
